// extracted by mini-css-extract-plugin
module.exports = {"cn8s3o7":"cn8s3o7","l1a1dqu7":"l1a1dqu7"};